export const getOrderStatus = (status) => {
    console.log('status>', status)
    if (status === 'SUCCESS') return <span style={{color: '#AADD6A'}}>Success</span>;
    if (status === 'PENDING') return  <span style={{color: '#DDB16A'}}>Pending</span>;

    return <span style={{color: '#DD6A6A'}}>{status}</span>
}